export const styles = () => ({
  '.dn-notifications': {
    marginTop: '-2px !important',
    marginLeft: '-2px !important',
    '& > div.MuiGrid-item': {
      paddingLeft: '2px !important',
      paddingTop: '2px !important',
    },
    '.dn-notification': {
      padding: '19px 40px',
      '.dn-summary': {
        fontSize: '15px',
        lineHeight: '19px',
        color: '#4B4B4B',
        marginRight: '5px',
        strong: {
          fontWeight: '700',
        },
      },
      '.dn-date': {
        color: '#AEAEAE',
        marginLeft: '5px',
        fontWeight: '400',
      },
      'a.dn-detail': {
        fontWeight: '400',
        marginLeft: '5px',
        color: '#2845D2',
        textDecoration: 'none',
      },
      '&.dn-background': {
        background: '#FAFAFA',
      },
      '.MuiButtonBase-root': {
        border: '1px solid transparent',
        '& > div': {
          width: '4px',
          height: '4px',
          background: '#2845D2',
          borderRadius: '500px',
        },
        '&.dn-read': {
          '& > div': {
            background: 'transparent',
          },
        },
        '&:hover': {
          border: '1px solid #2845D2',
        },
      },
      '&:hover': {
        background: 'rgba(40, 69, 210, 0.05)',
        '.dn-detail': {
          textDecoration: 'underline',
        },
        '.MuiButtonBase-root': {
          background: 'rgba(0, 0, 0, 0.04)',
        },
      },
    },
  },
  '.dn-notification-title': {
    fontSize: '16px',
    lineHeight: '20px',
    color: '#4B4B4B',
    borderBottom: '1px solid rgba(75, 75, 75, 0.1)',
    paddingBottom: '15px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
    paddingLeft: '40px',
    paddingRight: '40px',
    position: 'sticky',
    top: '0',
    zIndex: '1',
    background: '#fff',
  },
  '.dn-notifications-status-icon': {
    marginRight: '20px',
    padding: '0 !important',
    '.MuiSvgIcon-root': {
      fontSize: '21px !important',
    },
  },
});
